export function header(method = 'POST', nonce) {
    if (method === 'PUT' || method === 'DELETE')
        return { 'Accept': 'application/json', 'Content-Type': 'application/json', 'X-WP-Nonce': nonce };
    else
        return { 'Accept': 'application/json', 'X-WP-Nonce': nonce };
}